import { useState } from 'react';
import { Formik } from 'formik';
import { Button, Form, Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

import {
  changePasswordInitialValues,
  changePasswordValidationSchema,
} from '../validations/changePasswordValidation';

import { CustomPasswordInput, CustomInput } from './form';

const PasswordChange = ({
  handleValidSubmit,
  loading = false,
  toggle = null,
  isFromForgotPassword = false,
}) => {
  const { t } = useTranslation();
  const [isShownPass, setIsShownPass] = useState(false);
  return (
    <Formik
      initialValues={changePasswordInitialValues}
      onSubmit={(values) => {
        handleValidSubmit(values);
      }}
      validationSchema={changePasswordValidationSchema(t)}
    >
      {({ handleSubmit, isSubmitting }) => (
        <Form onSubmit={handleSubmit}>
          <CustomPasswordInput
            id="password"
            name="password"
            labelText={t('formulary.new_password')}
            placeholder={t('formulary.placeholder.enter_new_password')}
          />

          <CustomInput
            id="confirmPassword"
            name="confirmPassword"
            placeholder={t('formulary.placeholder.confirm_password')}
            labelText={t('formulary.placeholder.enter_confirm_password')}
            type={isShownPass ? 'text' : 'password'}
            icon={
              <Icon
                name={isShownPass ? 'eye' : 'eye slash'}
                onClick={() => {
                  setIsShownPass(!isShownPass);
                }}
                link
              />
            }
          />

          {!toggle && !isFromForgotPassword ? (
            <Button
              disabled={loading}
              loading={loading}
              type="submit"
              className="Primary-Button"
            >
              {t('actions.change')}
            </Button>
          ) : (
            !toggle &&
            isFromForgotPassword && (
              <Button
                type="submit"
                className="btn btn-primary signin-button"
                loading={loading}
                disabled={loading}
              >
                {t('actions.reset_password')}
              </Button>
            )
          )}

          {toggle && !isFromForgotPassword && (
            <div className="model-buttons">
              <Button
                className="modal-cancel"
                type="button"
                onClick={() => toggle()}
              >
                {t('actions.cancel')}
              </Button>
              <Button
                content={t('actions.reset')}
                type="submit"
                className="modal-proceed"
              />
            </div>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default PasswordChange;
